import './css/style.css'
import './css/metronic.css'
import './css/plugins.bundle.css'
import ReactDOM from 'react-dom/client'
import Modules from "./modules/Modules";

// Display Canvas
const root = ReactDOM.createRoot(document.querySelector('#visualizer'));

root.render(
    <Modules
        room={room}
        products={products}
        previousPage={previousPage}
    />
);